import * as React from 'react';
import { useDispatch } from 'react-redux';
import { deleteLibrary } from '../store/libraries.store';
import { ModalContainer } from '@moovly/ui';
import { t } from '@moovly/i18n';
import { Library } from '@moovly/clients/lib/resources/libraries/libraries.interfaces';
import { DefaultModalProps } from '../../../types/modal';

interface DeleteLibraryModalProps extends DefaultModalProps {
  library: Library;
}

const DeleteLibraryModal: React.FC<DeleteLibraryModalProps> = ({ closeModal, library, setOpen }) => {
  const dispatch = useDispatch<any>();
  const handleConfirm = React.useCallback(() => {
    if (!!library) {
      dispatch(deleteLibrary({ libraryId: library.id }));
    }
    closeModal();
  }, [dispatch, closeModal, library]);
  return (
    <ModalContainer
      setOpen={setOpen}
      title={t('libraries.deleteModal.title')}
      description={t('libraries.deleteModal.description')}
      confirmButtonText={t('libraries.deleteModal.delete')}
      onConfirm={handleConfirm}
      isOpen={!!library}
    />
  );
};

export default DeleteLibraryModal;
